export const participantConstants = {
    PARTICIPANT_GET_APPLICATION_REQUEST:"PARTICIPANT_GET_APPLICATION_REQUEST",
    PARTICIPANT_GET_APPLICATION_COMPLETE:"PARTICIPANT_GET_APPLICATION_COMPLETE",

    PARTICIPANT_GET_PARTICIPANT_SUMMARY_REQUEST:"PARTICIPANT_GET_PARTICIPANT_SUMMARY_REQUEST",
    PARTICIPANT_GET_PARTICIPANT_SUMMARY_COMPLETE:"PARTICIPANT_GET_PARTICIPANT_SUMMARY_COMPLETE",

    PARTICIPANT_GET_AREAS_REQUEST:"PARTICIPANT_GET_AREAS_REQUEST",
    PARTICIPANT_GET_AREAS_COMPLETE:"PARTICIPANT_GET_AREAS_COMPLETE",

    PARTICIPANT_GET_DEALERS_REQUEST:"PARTICIPANT_GET_DEALERS_REQUEST",
    PARTICIPANT_GET_DEALERS_COMPLETE:"PARTICIPANT_GET_DEALERS_COMPLETE",

    PARTICIPANT_GET_JOB_ROLES_REQUEST:"PARTICIPANT_GET_JOB_ROLES_REQUEST",
    PARTICIPANT_GET_JOB_ROLES_COMPLETE:"PARTICIPANT_GET_JOB_ROLES_COMPLETE",

    PARTICIPANT_SAVE_NEW_PARTICIPANT_REQUEST:"PARTICIPANT_SAVE_NEW_PARTICIPANT_REQUEST",
    PARTICIPANT_SAVE_NEW_PARTICIPANT_COMPLETE:"PARTICIPANT_SAVE_NEW_PARTICIPANT_COMPLETE",

    PARTICIPANT_UPDATE_PARTICIPANT_STATUS_REQUEST:"PARTICIPANT_UPDATE_PARTICIPANT_STATUS_REQUEST",
    PARTICIPANT_UPDATE_PARTICIPANT_STATUS_COMPLETE:"PARTICIPANT_UPDATE_PARTICIPANT_STATUS_COMPLETE",

    PARTICIPANT_DELETE_REQUEST:"PARTICIPANT_DELETE_REQUEST",
    PARTICIPANT_DELETE_COMPLETE:"PARTICIPANT_DELETE_COMPLETE",

    PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_REQUEST:"PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_REQUEST",
    PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_COMPLETE:"PARTICIPANT_SEND_PARTICIPANT_ACTIVATION_COMPLETE",

    PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_REQUEST:"PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_REQUEST",
    PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_COMPLETE:"PARTICIPANT_SEND_PARTICIPANT_UPDATE_DEALER_SHIP_COMPLETE",

    PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_REQUEST:"PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_REQUEST",
    PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_COMPLETE:"PARTICIPANT_SEND_PARTICIPANT_UPDATE_PARTICIPANT_JOB_ROLE_COMPLETE",

    PARTICIPANT_APPLICATION_EQUIPE:"Equipe",
    PARTICIPANT_APPLICATION_TLC:"TLC",

    PARTICIPANT_GET_TLC_CUSTOMERS_REQUEST: "PARTICIPANT_GET_TLC_CUSTOMERS_REQUEST",
    PARTICIPANT_GET_TLC_CUSTOMERS_COMPLETE: "PARTICIPANT_GET_TLC_CUSTOMERS_COMPLETE",

    PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_REQUEST: "PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_REQUEST",
    PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_COMPLETE: "PARTICIPANT_GET_CAMPAIGN_MEASUREMENT_COMPLETE",

}
